// Ориентировочные курсы валют к GEL для подсказки оператору в форме кассы.
//
// ⚠️ Это НЕ боевой источник курса. Настоящие курсы — динамические NBG
// (модель CashboxRate, кэш 24ч, эндпоинт getRates). Здесь — статичный
// ФОЛБЭК/ОРИЕНТИР только для UI-подсказки в форме сделки, вынесенный сюда из
// хардкода в admin DealBlock.tsx (волна 6, карточка rub-gel-rate-constant):
// единый источник истины + contract-тест на значения (правила 1 и 2 «никаких
// хардкодов денег», единый источник). UI обязан помечать подсказку как
// приблизительную, а не как «курс НБГ».
//
// Живое подключение getRates() в форму (чтобы подсказка была актуальной) —
// отдельная карточка, см. docs/plans/2026-05-21-admin-design-realign.md и
// docs/debt.md. Меняешь значения здесь → это осознанное изменение денежного
// ориентира: сначала правишь contract-тест.
export const CASHBOX_FALLBACK_RATE_TO_GEL = {
    GEL: 1,
    EUR: 2.95,
    USD: 2.71,
    RUB: 0.029,
    UAH: 0.066,
    USDT: 2.71,
};
//# sourceMappingURL=rateDefaults.js.map